import { Component, ElementRef, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { BlockingSpinnerService } from './blocking-spinner.service';

@Component({
  selector: 'blocking-spinner',
  templateUrl: './blocking-spinner.component.html',
  styleUrls: ['./blocking-spinner.component.scss'],
})
export class BlockingSpinnerComponent implements OnInit, OnDestroy {

  element: any;
  isOpen = false;

  constructor(
    private blockingSpinnerService: BlockingSpinnerService,
    private _element: ElementRef,
    private _renderer: Renderer2) {
    this.element = _element.nativeElement;
  }

  ngOnInit(): void {
    // add self (this blocking-spinner instance) to the blocking-spinner service so it's accessible from controllers
    this.blockingSpinnerService.init(this);
  }

  // remove self from blocking-spinner service when directive is destroyed
  ngOnDestroy(): void {
    this.blockingSpinnerService.destroy();
    this.element.remove();
  }

  // open blocking-spinner
  open(): void {
    this.isOpen = true;
    this._renderer.addClass(this.element, 'show');
  }

  // close blocking-spinner
  close(): void {
    this.isOpen = false;
    this._renderer.removeClass(this.element, 'show');
  }
}
